import { useTranslation } from 'react-i18next';

export const useNonStatutoryTimelinessResponseStatsLabels = (): Record<string, string> => {
  const { t } = useTranslation('non_statutory_timelines_response_stats_annual_dfi_report');

  const nonStatutoryTimelinessResponseStatsLabels: Record<string, string> = {
    totalConsultationRequestsReceived: t(
      'total_consultation_requests_received_non_statutory',
      'Total number of non-statutory consultation requests received'
    ),
    totalConsultationsRespondedInAgreedTimeframe: t(
      'total_consultations_responded_in_agreed_timeframe_non_statutory',
      'Total number of non-statutory consultations responded to in the agreed timeframe'
    ),
    percentageConsultationsRespondedInAgreedTimeframe: t(
      'percentage_non_statutory_consultations_responded_in_agreed_timeframe',
      'Percentage of non-statutory consultations responded to in the agreed timeframe'
    ),
    totalConsultationsWithResponsesWithin21Days: t(
      'total_consultations_with_responses_within_21_days_non_statutory',
      'Total number of non-statutory consultations with substantive responses made within 21 calendar days'
    ),
    percentageConsultationsWithResponsesWithin21Days: t(
      'percentage_non_statutory_consultations_with_responses_within_21_days',
      'Percentage of of non-statutory consultations with substantive responses made within 21 calendar days'
    ),
    totalConsultationsRespondedLate: t(
      'total_consultations_responded_late_non_statutory',
      'Total number of non-statutory consultations responded to late'
    ),
    percentageConsultationsRespondedLate: t(
      'percentage_non_statutory_consultations_responded_late',
      'Percentage of non-statutory consultations responded to late'
    ),
    totalConsultationsWithOutstandingResponses: t(
      'total_consultations_with_outstanding_responses_non_statutory',
      'Total number of non-statutory consultations with outstanding responses'
    ),
    averageDaysTakenToRespondRequests: t(
      'average_days_taken_to_respond_requests_non_statutory',
      'Average number of days taken to make a substantive response to non statutory requests'
    ),
  };
  return nonStatutoryTimelinessResponseStatsLabels;
};
